import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import FAQSection from '../../components/User/Home/FAQSection'

const FAQs = () => {
  return (
    <div>
        <SimpleBanner title='FAQ`S' subheading='Home > Company > FAQ' />
        <div>
        <FAQSection/>
        </div>
    </div>
  )
}

export default FAQs